import _ from '../utils'
import CAPTCHA_CONFIG from './config'
import API from '../api'
import API_HINT from '../api-hint'
import API_PROGRESS from '../../core/api-progress'
import qs from 'qs'

class CaptchaClass {
    constructor() {
        this.publicKey = CAPTCHA_CONFIG.publicKey
    }

    _verify( form, callback ) {
        event.preventDefault()
        API_PROGRESS._loading( form )
        grecaptcha.ready( () => {
            grecaptcha.execute( CAPTCHA_CONFIG.publicKey, { action: 'submit' }).then( ( token ) => {
                API.post( 'captcha/verify/', 
                    qs.stringify({
                        token: token,
                    })
                ).then( ( response ) => {
                    if ( response.data.success ) {
                        callback()
                    } else {
                        API_HINT._open( 'is--error', response.data.message )
                        API_PROGRESS._loaded( form )
                    }
                    
                }).catch( ( err ) => {
                    console.log( err )
                    API_HINT._open( 'is--error', API_HINT.error )
                    API_PROGRESS._loaded( form )
                })
            })
        })
    }
}


const CAPTCHA = CAPTCHA_CONFIG != '' ? new CaptchaClass() : null
export default CAPTCHA